import { render, staticRenderFns } from "./white-form.vue?vue&type=template&id=62dd35e4&scoped=true&"
import script from "./white-form.vue?vue&type=script&lang=js&"
export * from "./white-form.vue?vue&type=script&lang=js&"
import style0 from "./white-form.vue?vue&type=style&index=0&id=62dd35e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd35e4",
  null
  
)

export default component.exports